import type React from "react";
import "./Card.scss";

type CardProps = {
  children: React.ReactNode;
  className?: string;
} & React.HTMLAttributes<HTMLElement>;

export const Card: React.FC<CardProps> = ({ children, className, ...props }) => {
  const combinedClassName = `card ${className || ""}`.trim();

  return (
    <div className={combinedClassName} onClick={props.onClick}>
      {children}
    </div>
  );
};
